import { cn } from '@/lib/utils'
import { isSmallScreenAtom } from '@/atoms/screenSize'
import { Event } from '@nostr/tools/wasm'
import { useAtomValue } from 'jotai'
import LikeButton from './LikeButton'
import ReplyButton from './ReplyButton'
import QuoteButton from './QuoteButton'
import RepostButton from './RepostButton'
import SeenOnButton from './SeenOnButton'

export default function NoteStats({
  event,
  className,
  classNames
}: {
  event: Event
  className?: string
  classNames?: {
    buttonBar?: string
  }
  fetchIfNotExisting?: boolean
}) {
  const isSmallScreen = useAtomValue(isSmallScreenAtom)

  if (isSmallScreen) {
    return (
      <div className={cn('select-none overflow-visible', className)}>
        <div
          className={cn(
            'flex justify-between items-center h-5 [&_svg]:size-5',
            classNames?.buttonBar
          )}
          onClick={(e) => e.stopPropagation()}
        >
          <ReplyButton event={event} />
          <RepostButton event={event} />
          <QuoteButton event={event} />
          <LikeButton event={event} />
          <SeenOnButton event={event} />
        </div>
      </div>
    )
  }

  return (
    <div className={cn('select-none overflow-visible', className)}>
      <div
        className={cn('flex justify-evenly h-5 [&_svg]:size-4 items-center')}
        onClick={(e) => e.stopPropagation()}
      >
        <ReplyButton event={event} />
        <RepostButton event={event} />
        <QuoteButton event={event} />
        <LikeButton event={event} />
        <SeenOnButton event={event} />
      </div>
    </div>
  )
}
